// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"e9456c60","280":"93dead3d","494":"0f76e539"}[chunkId] + ".chunk.js";
};